import CodeBase from "./CodeBase.js"

// 시나리오 작성 의뢰 요청 상태 코드

class ScenarioServiceRequestStatus extends CodeBase {
  constructor() {
    const CODE_MAP = {
      'A' : '접수중',
      'B' : '작업중',
      'C' : '테스트 가능',
      'D' : '운영중',
      'E' : '운영 종료',
      'F' : '취소'
    };

    super(CODE_MAP);
  }
}

export default ScenarioServiceRequestStatus;
